<template>
	<div class="layout-topbar">
		<button class="p-link layout-menu-button" @click="onMenuToggle">
			<span class="pi pi-bars"></span>
		</button>
		<div class="layout-topbar-icons">	
			<Chip class="p-mr-2">&nbsp; <i class="pi pi-fw pi-user"></i> &nbsp; {{nombreusuario.nomuser}}&nbsp;|&nbsp;{{nombreusuario.noplaza}} &nbsp;</Chip>
		</div>
	</div>
</template>

<script>
export default {
	data() {
			return {
				nombreusuario: {
					nomuser: window.localStorage.getItem('nombreDocenteUser'),
					noplaza: window.localStorage.getItem('noPlaza')
				},
				expanded: false
			}
		},
    methods: {		
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        }
    }
}
</script>
<style lang="scss" scoped>
.p-chip.custom-chip {
    background: var(--primary-color);
    color: var(--primary-color-text);
}
</style>